/* eslint-disable */

import fancybox from '@fancyapps/fancybox';
import lozad from 'lozad';

export default {
  init() {
    // JavaScript to be fired on all pages
    const observer = lozad();
    observer.observe();

    (function($) {

      if(window.location.hash) {
        var scrollHash = window.location.hash;
        var scrollEl = $('[data-scroll-id="' + scrollHash + '"]');
        $('html, body').animate({
            scrollTop: scrollEl.offset().top - 200
        }, 600);
      }

      $('.smooth-scroll').click(function(){
        var scrollHash = $(this).attr('href');
        var scrollHash = scrollHash.replace('/', '');
        var scrollEl = $('[data-scroll-id="' + scrollHash + '"]');
        $('html, body').animate({
            scrollTop: scrollEl.offset().top - 200
        }, 600);

      })

      $(window).scroll(function() {
      var height = $(window).scrollTop();
      if(height >= 500) {
          // do something
          // $('.side-cta').css('display', 'flex');
          $('.parter-side-cta').removeClass('parter-side-cta-hide');
      } else {
        // $('.side-cta').css('display', 'none');
        $('.parter-side-cta').addClass('parter-side-cta-hide');
      }
    });

      // Smooth Scroll

      $(document).on('click', 'a[href^="#"]', function (event) {
            event.preventDefault();

            $('html, body').animate({
                scrollTop: $($.attr(this, 'href')).offset().top - 200,
            }, 500);
        });

      $('.fake-checkbox').click(function(){
        var $this = $(this);
        if ($this.find('input').is(':checked')) {
          $this.addClass('active');
        } else {
          $this.removeClass('active');
        }
      });

      $('.fake-radio-toggle').click(function(){
        var $this = $(this);

        $this.parent().find('input').not($this.find('input')).prop('checked', false);
        $this.parent().find('.fake-radio').removeClass('active');

        if ($this.find('input').is(':checked')) {
          $this.find('.fake-radio').addClass('active');
        } else {
          $this.find('.fake-radio').removeClass('active');
        }

      });

      $('#module-exam .fake-radio-toggle').click(function(){
        var $this = $(this);

        $this.parent().siblings().find('input').prop('checked', false);
        $this.parent().siblings().find('.fake-radio').removeClass('active');

        if ($this.find('input').is(':checked')) {
          $this.find('.fake-radio').addClass('active');
        } else {
          $this.find('.fake-radio').removeClass('active');
        }

        // var examQuestions =  $('.module-exam-question').length;
        // var activeAnswers =  $('.fake-radio.active').length;
        // var examProgress = activeAnswers / examQuestions;
        //
        // var examProgress = examProgress * 100;
        //
        // $('.exam-progress-bar-inner').css('width', examProgress + '%');
        // $('#exam-progress').text(Math.round(examProgress));

      });

      // Modals
      $('button[name="video-modal"]').click(function(){
        $('#video-modal').addClass('active');

        var video = $('#video-modal').find('video');
        video[0].play();


      });

      $('#video-modal .modal-close').click(function(){
        var video = $('#video-modal').find('video');
        video[0].pause();
      });

      $('button[name="toggle-modal"]').click(function(){
        $('.modal-background').addClass('active');
      });

      $('.modal-close').click(function(){
        $('.modal-background').removeClass('active');
        if(!$('.endurance-hardware-boards').hasClass('hidden')) {
          $('.endurance-hardware-boards').addClass('hidden');
        }
        if(!$('.endurance-hardware-boards-price').hasClass('hidden')) {
          $('.endurance-hardware-boards-price').addClass('hidden');
        }
      });

      // Order Modal
      $('button[name="order-modal"]').click(function(){
        $('#order-modal').addClass('active');
        var $this = $(this);
        console.log($this.data('custom-content'));
        if($this.data('custom-content') === 'ENDURANCE-HARDWARE-BOARDS') {
          console.log('endurance-hardware-boards');
          $('.endurance-hardware-boards').removeClass('hidden');
          $('.endurance-hardware-boards-price').removeClass('hidden');
        }
      });

      $('button[name="order-form-next"]').click(function(){
        var activeStep = $('.order-form-step.active');
        activeStep.next().addClass('active');
        activeStep.removeClass('active');
      });

      $('button[name="order-form-previous"]').click(function(){
        var activeStep = $('.order-form-step.active');
        activeStep.prev().addClass('active');
        activeStep.removeClass('active');
      });

      // Video Search
      $('button[name="video-search-button"]').click(function() {
        filterVideos();
      })

      function filterVideos() {
        var input = $('#video-search-input').val().toLowerCase();
        input = input.trim(input);

        $('.video-item').each(function(){
          var title = $(this).find('h3').html().toLowerCase();
          title.trim(title);
          if(title.includes(input)) {
            $(this).addClass('active');
          } else {
            $(this).removeClass('active');
          }
        });

      }

      // Mega Menu
      $('.mega-menu-item').hover(
        function(){
          var targetMenu = $(this).data('mega-menu');
          $(targetMenu).show();
          $('.mega-menu-blur').show();
        },
        function(){
          $('.mega-menu').hide();
          $('.mega-menu-blur').hide();
        }
      );

      $('.mega-menu').hover(
        function(){
          $(this).show();
          $('.mega-menu-blur').show();
        },
        function(){
          $(this).hide();
          $('.mega-menu-blur').hide();
        }
      );

      // Mobile Nav
      $('#nav-primary-toggle').click(function() {
        $(this).toggleClass('open');

        $('#mobile-menu').toggleClass('open');
        $('.nav-backdrop').toggleClass('show');
      });

      $('#menu-header-menu li.menu-item-has-children').append('<div class="menu-chevron toggle absolute z-20 top-0 right-0 bottom-0 px-2 py-1"><svg class=""version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="25px" height="15px" viewBox="0 0 284.929 284.929" style="enable-background:new 0 0 284.929 284.929;" xml:space="preserve"> <path d="M282.082,76.511l-14.274-14.273c-1.902-1.906-4.093-2.856-6.57-2.856c-2.471,0-4.661,0.95-6.563,2.856L142.466,174.441 L30.262,62.241c-1.903-1.906-4.093-2.856-6.567-2.856c-2.475,0-4.665,0.95-6.567,2.856L2.856,76.515C0.95,78.417,0,80.607,0,83.082 c0,2.473,0.953,4.663,2.856,6.565l133.043,133.046c1.902,1.903,4.093,2.854,6.567,2.854s4.661-0.951,6.562-2.854L282.082,89.647 c1.902-1.903,2.847-4.093,2.847-6.565C284.929,80.607,283.984,78.417,282.082,76.511z"/> </svg></div>');

      var timing = 200;

      $('#menu-header-menu > li.menu-item-has-children > .toggle').click(function() {
        if ($(this).parent().hasClass('open')) {
          $(this).parent().parent().find('li.menu-item-has-children').removeClass('open');
          $(this).parent().parent().find('.sub-menu').slideUp(timing);
        } else {
          $(this).parent().parent().find('li.menu-item-has-children.open').removeClass('open');
          $(this).parent().parent().find('li.menu-item-has-children.open > .sub-menu').slideUp(timing);
          $(this).parent().toggleClass('open');
          $(this).prev().slideDown(timing);
        }
      });

      // $('#menu-header-menu > li.menu-item-has-children > .sub-menu > li.menu-item-has-children > .toggle').click(function() {
      //   if ($(this).parent().hasClass('open')) {
      //     $(this).parent().parent().find('li.menu-item-has-children').removeClass('open');
      //     $(this).parent().parent().find('.sub-menu').slideUp(timing);
      //   } else {
      //     $(this).parent().parent().find('li.menu-item-has-children.open').removeClass('open');
      //     $(this).parent().parent().find('li.menu-item-has-children.open > .sub-menu').slideUp(timing);
      //     $(this).parent().toggleClass('open');
      //     $(this).prev().slideToggle(timing);
      //   }
      // });

      // Desktop nav
      $('#menu-header-menu > li > .sub-menu > li.menu-item-has-children').hover(function() {
        if( $(window).innerWidth() > 991 ) {
          var target = $(this).find('> ul.sub-menu');
          var width = $(target).outerWidth();

          var right_of_screen = $(window).innerWidth();
          var right_of_parent = $(this).offset().left + $(this).outerWidth();
          var right_of_element = right_of_parent + width;

          if (right_of_screen > right_of_element){
            $(target).css('transform', 'translateX(100%)');
            $(target).css('right', '0');
          } else {
            $(target).css('transform', 'translateX(-100%)');
            $(target).css('left', '0');
          }
        }
      });

      // Bowing Form
      $('#issue_nature').on('change', function(){
        var issueNature = $(this).val();
        if (issueNature == 'Bowed Slab') {
          var form = $(this).parent().parent().parent().parent();
          $('.default-part-options').hide();
          $('.bowed-slab-part-options').show();
          $('.bowing-procedure').show();

          form.attr('data-form-name', 'Bowed Slab Report ticket');
          form.find('input[name="form_name"]').attr('value', 'Bowed Slab Report ticket');
        } else {
          $('.default-part-options').show();
          $('.bowed-slab-part-options').hide();
          $('.bowing-procedure').hide();
        }
      });

      // Slick

      // $('.amicus_product_details-media-slider').slick({
      //   dots: false,
      //   arrows: false,
      //   cssEase: 'ease-in-out',
      //   slidesToShow: 3,
      //   slidesToScroll: 1,
      //   infinite: false,
      // });

      var amicusProductDetailsMediaSlider = {
        dots: false,
        arrows: false,
        cssEase: 'ease-in-out',
        slidesToShow: 3,
        slidesToScroll: 1,
        infinite: false,
      };

      $('.amicus_product_details-media-slider').slick(amicusProductDetailsMediaSlider);
      
      $('.media-prev').click(function() {
        $(this).parent().find('.amicus_product_details-media-slider').slick('slickPrev');
      });
      $('.media-next').click(function() {
        $(this).parent().find('.amicus_product_details-media-slider').slick('slickNext');
      });

      $('.amicus_product_details .hotspot').on('click', function() {
        var product = $(this).data('product');
        $('.amicus_product_details .hotspot').removeClass('active');
        $(this).addClass('active');
        $('.hotspot-content').addClass('hidden');
        $('.hotspot-content[data-product="' + product + '"]').removeClass('hidden');
        $('.amicus_product_details-media-inner').removeClass('active');
        $('.amicus_product_details-media-inner').find('.amicus_product_details-media-slider').slick('unslick');
        $('.amicus_product_details-media-inner[data-product="' + product + '"]').addClass('active');
        $('.amicus_product_details-media-inner[data-product="' + product + '"]').find('.amicus_product_details-media-slider').slick(amicusProductDetailsMediaSlider);
     });

      $('.amicus-cta-card-slider').slick({
        dots: false,
        arrows: false,
        fade: true,
        cssEase: 'ease-in-out',
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: false,
        asNavFor: '.amicus-cta-card-content-slider',
      });

      $('.amicus-cta-card-content-slider').slick({
        dots: false,
        arrows: false,
        fade: true,
        cssEase: 'ease-in-out',
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: false,
        asNavFor: '.amicus-cta-card-slider',
      });
      $('.brochure-prev').click(function() {
        $(this).parent().find('.amicus-cta-card-slider').slick('slickPrev');
      });
      $('.brochure-next').click(function() {
        $(this).parent().find('.amicus-cta-card-slider').slick('slickNext');
      });

      $('.module-gallery').slick({
        dots: true,
        arrows: false,
        fade: true,
        cssEase: 'ease-in-out',
        slidesToShow: 1,
        slidestoScroll: 1,
        autoplay: true,
        autoplaySpeed: 4000,
        speed: 1000,
        infinite: true,
      });

      $('.training-course-images').slick({
        dots: true,
        arrows: false,
        fade: true,
        cssEase: 'ease-in-out',
        slidesToShow: 1,
        slidestoScroll: 1,
        autoplay: true,
        autoplaySpeed: 4000,
        speed: 1000,
        infinite: true,
      });

      $('.testimonial-slider').slick({
        dots: true,
        arrows: false,
        fade: true,
        cssEase: 'ease-in-out',
        slidesToShow: 1,
        slidestoScroll: 1,
        autoplay: true,
        autoplaySpeed: 4000,
        speed: 1000,
        infinite: true,
      });

      $('.slick-p').click(function() {
        $(this).parent().prev().slick('slickPrev');
      });
      $('.slick-n').click(function() {
        $(this).parent().prev().slick('slickNext');
      });

      $('.filter-dropdown').click(function(){
        $(this).find('.filter-dropdown-items').toggle();
      });

			$('.filter-dropdown-items .mixitup-control').click(function(){
				$('.filter-dropdown-items').hide();
			});

      $('.training-courses-toggle').click(function(){
        $('.training-courses').slideToggle();
        $(this).toggleClass('active');
      });
      // Training Courses Search

      $('input[name="training-course-search-input"]').keyup(function() {
        filterTrainingCards();
      })

      function filterTrainingCards() {
        var input = $('input[name="training-course-search-input"]').val().toLowerCase();
        input = input.trim(input);

        $('.training-course-card').each(function(){
          var title = $(this).find('h3').html().toLowerCase();
          title.trim(title);
          if(title.includes(input)) {
            $(this).removeClass('not-active');
          } else {
            $(this).addClass('not-active');
          }
        });
      }

      // Cookie Policy
      $.fn.CookieNotice = function() {
        if (!localStorage.getItem('cookie-notice-dismissed')) {
          var notice = this;
          setTimeout(function() {
            notice.addClass('active');
          }, 1000);
        }
        this.addClass('cookie-notice');
        return this
      }
      $(document).on('click', '.cookie-notice-dismiss', function() {
        localStorage.setItem('cookie-notice-dismissed', true);
        $(this).parents('.cookie-notice').removeClass('active');
      })
      $('#cookie-notice').CookieNotice();

      // Share Button
      $('.page-share').click(function() {
        if( navigator.share ) {
          navigator.share({
            title: 'Share This Page',
            url: 'https://google.com',
          }).then(() => {
            console.log('Thanks for sharing!');
          })
          .catch(err => {
            console.log('Couldnt share because of', err.message);
          });
        } else {
          $('#panel-share').toggleClass('active');
          console.log('navigator.share not supported!')
        }
      });

      $('.panel-share-close').click(function() {
        $('#panel-share').removeClass('active');
      });

      // Door Designs
      $('button[name="door-style-button"]').click(function() {
        var value = $( '#door-design-select option:selected' ).val();

        $('.door-design').removeClass('active');
        $('#' + value).addClass('active');
      });


      // Play Video
        var $window = $(window);

        $window.scroll(function() {
          $('.animated-image-scroll').each(function () {

            var $video = $(this);
            var $videoSrc = $video.attr('src');

            if ($video.attr('src') != '') {

              if ($video.is(":in-viewport")) {
                $video[0].play();
                $video[0].onended = function() {
                  $video.attr('src', '');
                  $video.hide();
                  $video.fadeIn('fast');
                }
              } else {
                $video[0].pause();
                $video.attr('src', $videoSrc);
              }

            }

          });

        });

        // Installer faq

        $('.accordion-header').click(function(){
          if ($(this).hasClass('header-active')) {
            return;
          }
          $('.accordion-header').each(function(){
            $(this).removeClass('header-active');
          });
          $(this).addClass('header-active');

          $('.accordion-content').each(function(){
            $(this).slideUp();
          });

          $(this).parent().children('.accordion-content').slideDown();
        });

        // Image tooltip block

        $('.tooltip-wrap p').click(function(){
          $('.tooltip-wrap div').each(function(){
            $(this).addClass('hidden');
          });

          $(this).siblings('.tooltip-wrap div').removeClass('hidden');
        });

        $('.tooltip-close').click(function(){
          $(this).parent().addClass('hidden');
        });

        // Benefits rotate

        $('.title-pane').click(function(){
          $('.active-content').each(function(){
            $(this).removeClass('active-content');
          });

          $(this).parent().addClass('active-content');
        });

        // Case study - read more link

        $('.case-read-more, .case-read-less').click(function(){
          $('.case-excerpt').toggleClass('hidden');
          $('.case-full').toggleClass('hidden');
        });

        // Costings Form

        $('#section_costings button, .partner-apply-now').click(function(){
          $('#section_costings button').hide();

          $('#section_costings form').slideDown({
            start: function () {
              $(this).css({
                display: "flex"
              })
            }
          });
        });

        // Download Brochure CTA/Modal
        var brochureLinks = $('.download-brochure-modal input[name="details[brochure_links]"]');
        var brochureNames = $('.download-brochure-modal input[name="details[brochure_name]"]');
        $('.download-brochure-btn').on('click', function () {
          $('.download-brochure-modal img').attr('src', '');
          var brochureName = $(this).data('brochure-name');
          var brochureImage = $(this).data('brochure-image');
          var brochureFile = $(this).data('file');
          $('.download-brochure-modal').addClass('active');
          $('.download-brochure-modal img').attr('src', brochureImage);
          $('.download-brochure-modal [name="details[brochure_name]"]').val(brochureName);
          $(`input[data-brochure-name="${brochureName}"]`).prop('checked', true);
          $(`.brochure-item[data-brochure-name="${brochureName}"]`).addClass('active');
          brochureLinks.val(brochureFile);
        });

        $('.download-brochure-modal .close-modal').on('click', function () {
            $('.download-brochure-modal').removeClass('active');
        });

        $('input[name="details[brochures]"]').on('change', function () {
          var selectedBrochures = [];
          var newBrochureLinks = [];
      
          $('input[name="details[brochures]"]').each(function () {
              if ($(this).is(':checked')) {
                  selectedBrochures.push($(this).data('brochure-name'));
                  newBrochureLinks.push($(this).data('file'));
              }
          });
          brochureLinks.val(newBrochureLinks.join(', '));
          brochureNames.val(selectedBrochures.join(', '));

          console.log(newBrochureLinks);
          
          console.log(brochureLinks);
        });

        // Full width video
        $('.amicus-full-video-play').on('click', function(){
          var videoURL = $(this).data('videourl');
          var videoElement = $(this).siblings('.amicus-full-video-element');
          videoElement.attr('src', videoURL);
          videoElement.removeClass('hidden');
          videoElement.get(0).play();
          $(this).addClass('hidden');
        });

        // Product details video
        $('.amicus_product_details-video-play').on('click', function(){
          var videoURL = $(this).data('videourl');
          var videoElement = $(this).siblings('.amicus_product_details-video');
          videoElement.attr('src', videoURL);
          videoElement.removeClass('hidden');
          videoElement.get(0).play();
          $(this).addClass('hidden');
          $(this).parent().find('.amicus_product_details-video-cover').addClass('hidden');
        });

        //  Amicus faqs

        $('.faq-heading').on('click', function(){
          $('.triangle-icon').removeClass('active');
          $('.faq-content').slideUp();
          $(this).toggleClass('active');
          $(this).find('.triangle-icon').toggleClass('active');
          $(this).siblings('.faq-content').slideToggle();
        });

        $(document).ready(function() {
          if($('[data-fancybox="hotspots-slides"]').length) {
            $('[data-fancybox="hotspots-slides"]').fancybox({
              // Optional settings
            });
          };
        });
        
    })(jQuery);
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js